<div class="course-preview-header">
  <div class="header-row">
    <div class="header-text">
  <div class="top-line">
    <i class="bi bi-arrow-left-short" (click)="goBack()"></i>
    <h3 class="course-heading fw-bold">Course Preview</h3>
  </div>
  <p class="sub-head">Review all course details before publishing</p>
</div>

 <div class="button-group">

  <ng-container *ngIf="!courseId">
    <button 
      class="btn btn-back" 
      (click)="goBackToPreviousStep()">
      <i class="bi bi-arrow-left"></i> Back to edit
    </button>
  <button 
      class="btn btn-publish" 
      (click)="publishCourse()" 
      [disabled]="isLoadingDraft || isLoadingPublish">
      <ng-container *ngIf="isLoadingPublish; else publishContent">
        <span class="spinner-border spinner-border-sm"></span> Publishing...
      </ng-container>
      <ng-template #publishContent>
        <img src="assets/images/publish.png" alt="publish" class="unit-icon"> Publish
      </ng-template>
    </button>
    <button 
      class="btn btn-draft" 
      (click)="saveAsDraft()" 
      [disabled]="isLoadingDraft || isLoadingPublish">
      <ng-container *ngIf="isLoadingDraft; else draftContent">
        <span class="spinner-border spinner-border-sm"></span> Saving...
      </ng-container>
      <ng-template #draftContent>
        <i class="bi bi-save"></i> Save as Draft
      </ng-template>
    </button>
  </ng-container>

  <ng-container *ngIf="courseId && status === courseStatus.Draft">
    <button 
      class="btn btn-publish" 
      (click)="publishCourse()" 
      [disabled]="isLoadingDraft || isLoadingPublish">
      <ng-container *ngIf="isLoadingPublish; else publishContent">
        <span class="spinner-border spinner-border-sm"></span> Publishing...
      </ng-container>
      <ng-template #publishContent>
        <img src="assets/images/publish.png" alt="publish" class="unit-icon"> Publish
      </ng-template>
    </button>

    <button 
      class="btn btn-outline" 
      (click)="openDeleteCourseDialogBox(courseId)">
      Delete Draft
    </button>
  </ng-container>

  <ng-container *ngIf="courseId && status === courseStatus.Published">
    <button 
      class="btn btn-unpublish" 
      (click)="openUnpublishDialogBox()">
      <img src="assets/images/publish.png" alt="publish" class="unit-icon"> Unpublish
    </button>
  </ng-container>

</div>

  </div>
  <div class="divider"></div>
</div>

<div *ngIf="coursePayload; else noCourse">

  <!-- Course Details -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-mortarboard-fill text-light"></i></div>
      <div class="course-details-title">
        Course Details
        <div class="course-details-subtitle">Basic information</div>
      </div>
    </div>
    <div class="course-details-content">
      <div class="course-details-row">
        <div class="course-details-col">
          <div class="course-details-label">COURSE NAME</div>
          <div class="course-details-value">{{ coursePayload.course_title || '-' }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">COURSE CODE</div>
          <div class="course-details-value">{{ coursePayload.course_code || '-' }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">GRADE LEVEL</div>
          <div class="course-details-value">{{ coursePayload.grade_level || '-' }}</div>
        </div>
      </div>
      <div class="course-details-row">
        <div class="course-details-col">
          <div class="course-details-label">CREDITS</div>
          <div class="course-details-value">{{ coursePayload.credits || 0 }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">CIE MARKS</div>
          <div class="course-details-value">{{ coursePayload.internal_marks || 0 }}</div>
        </div>
        <div class="course-details-col">
          <div class="course-details-label">SIE MARKS</div>
          <div class="course-details-value">{{ coursePayload.exam_marks || 0 }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Course Objectives -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-bullseye text-light"></i></div>
      <div class="course-details-title">
        Course Objectives
        <div class="course-details-subtitle">What students will learn</div>
      </div>
    </div>
    <div class="course-details-content">
      <ng-container *ngIf="coursePayload.course_objectives?.length; else noObjectives">
        <ul>
          <li *ngFor="let objective of coursePayload.course_objectives">{{ objective }}</li>
        </ul>
      </ng-container>
      <ng-template #noObjectives>
        <p class="text-muted text-center">No Objectives Available</p>
      </ng-template>
    </div>
  </div>

  <!-- Units -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-book text-light"></i></div>
      <div class="course-details-title">
        Units
        <div class="course-details-subtitle">Units, topics, and subtopics</div>
      </div>
    </div>
    <div class="course-details-content">
      <ng-container *ngIf="coursePayload.units?.length; else noUnits">
        <div class="unit-card" *ngFor="let unit of coursePayload.units">
          <div class="unit-header">
            <div class="unit-title-row">{{ unit.unit_title || '-' }}</div>
            <div class="unit-duration">Duration: {{ unit.unit_hours || 0 }} hours</div>
          </div>
          <div class="unit-topics">
            <ng-container *ngIf="unit.topics?.length; else noTopics">
              <div class="topic" *ngFor="let topic of unit.topics">
                <span class="dot"></span> {{ topic.topic_title || '-' }}
                <div class="subtopic" *ngFor="let sub of topic.subtopics || []">
                  <span class="sub-dot"></span> {{ sub.subtopic_title || '-' }}
                </div>
              </div>
            </ng-container>
            <ng-template #noTopics>
              <p class="text-muted text-center">No Topics Added Yet</p>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <ng-template #noUnits>
        <p class="text-muted text-center">No Units Added Yet</p>
      </ng-template>
    </div>
  </div>

  <!-- Course Outcomes -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-award-fill text-light"></i></div>
      <div class="course-details-title">
        Course Outcomes
        <div class="course-details-subtitle">Expected results</div>
      </div>
    </div>
    <div class="course-details-content">
      <ng-container *ngIf="coursePayload.course_outcomes?.length; else noOutcomes">
        <ul>
          <li *ngFor="let outcome of coursePayload.course_outcomes">{{ outcome }}</li>
        </ul>
      </ng-container>
      <ng-template #noOutcomes>
        <p class="text-muted text-center">No Outcomes Available</p>
      </ng-template>
    </div>
  </div>

  <!-- Textbooks & Web Resources -->
  <div class="course-details-card">
    <div class="course-details-header">
      <div class="course-details-icon"><i class="bi bi-cart-fill text-light"></i></div>
      <div class="course-details-title">
        Resources & References
        <div class="course-details-subtitle">Textbooks and web resources</div>
      </div>
    </div>
    <div class="course-details-content">

      <!-- Textbooks -->
      <ng-container *ngIf="coursePayload.textbooks?.length; else noTextbooks">
        <div class="resource-row">
          <div class="resource-title">Textbooks</div>
          <div class="resource-card" *ngFor="let book of coursePayload.textbooks; let i = index">
            <div class="resource-name-row">
              <span class="resource-count">{{ i + 1 }}</span>
              <span class="resource-name">{{ book.title || '-' }}</span>
            </div>
            <div class="resource-details">
              <span class="resource-author">{{ book.author || '-' }} | {{ book.publisher || '-' }} {{ book.year ? ', ' + book.year : '' }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noTextbooks>
        <p class="text-muted text-center">No Textbooks Added Yet</p>
      </ng-template>

      <!-- Web Resources -->
      <ng-container *ngIf="coursePayload.web_references_links?.length; else noWebResources">
        <div class="resource-row">
          <div class="resource-title">Web Resources</div>
          <div class="resource-card" *ngFor="let resource of coursePayload.web_references_links; let i = index">
            <div class="resource-name-row">
              <span class="resource-count">{{ i + 1 }}</span>
              <a [href]="resource" target="_blank">{{ resource }}</a>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noWebResources>
        <p class="text-muted text-center">No Web Resources Added Yet</p>
      </ng-template>

    </div>
  </div>
</div>

<ng-template #noCourse>
  <p class="text-center text-muted">No Course Data Available</p>
</ng-template>
 
